export let DateUtils = {

    firstDay: 1,

    getWeekRange(date: Date, firstDay?: number | any) {
        let startDate = this.getDateStartWeek(date, firstDay);
        let endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + 6);
        return {
            startWeek: startDate,
            endWeek: endDate
        }
    },

    getDayIndexOnWeek(date: Date, firstDay?: number | any): number {
        // Default start date on monday
        if (firstDay === undefined || firstDay < 0) {
            firstDay = this.firstDay;
        }

        if (date.getDay() < firstDay) {
            return 7 - date.getDay() - firstDay;
        } else {
            return date.getDay() - firstDay;
        }
    },

    getDateStartWeek(date: Date, firstDay?: number | any): Date {
        let distance = this.getDayIndexOnWeek(date, firstDay);
        date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        date.setDate(date.getDate() - distance);
        return date;
    },

    getDateEndWeek(date: Date, firstDay?: number | any): Date {
        let endDate = this.getDateStartWeek(date, firstDay);
        endDate.setDate(endDate.getDate() + 6);
        return endDate;
    },

    dayOfYear(date: Date): number {
        let jan = new Date(date.getFullYear(), 0, 1);
        jan.setTime(jan.getTime() - 1);
        return Math.ceil((date.getTime() - jan.getTime()) / 86400000);
    },

    getWeek(date: Date, firstDay?: number | any): number {
        let startYear = new Date(date.getFullYear(), 0, 1);
        let startWeek = this.getDateStartWeek(date, firstDay);
        let dayInYear = this.dayOfYear(startWeek);
        return Math.ceil(dayInYear / 7);
    },

    getDateFromWeek(w: number, y: number): Date {
        let d = (1 + (w - 1) * 7);
        return new Date(y, 0, d);
    },

    dateIsToday(date: any): boolean {
        let now = new Date();
        let compareDate = new Date(date);
        now.setHours(0, 0, 0, 0);
        compareDate.setHours(0, 0, 0, 0);
        return now.getTime() === compareDate.getTime();
    },

    weekIsToday(date: Date): boolean {
        return this.getWeek(date) === this.getWeek(new Date());
    },

    isSameWeek(a: Date, b: Date): boolean {
        return this.getWeek(a) === this.getWeek(b);
    }

};
